import React, {Component} from 'react';
import BaseComponent from "../../../../base/BaseComponent";

class MediaList extends BaseComponent {

    static defaultProps = {
        group: []
    };

    render() {
        let {group, hideMediaTitle,  showHref=false} = this.props;
        return (
            <div>
                {
                    group && group.length ? group.map((item, index) => {
                        return <MediaGroup key={index} {...item} hideMediaTitle={hideMediaTitle} showHref={showHref}/>;
                    }) : "公众号发布链接无法获取"
                }
            </div>
        );
    }
}


class MediaGroup extends BaseComponent {

    render() {
        const iconWidth = 20;
        const lineHeight = 40;
        return <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} valign={"middle"}>
            <tbody>
            {
                this.props.hideMediaTitle ? "" : (
                    <tr height={lineHeight}>
                        <td width={iconWidth}><img width={iconWidth} src={this.props.icon}/></td>
                        <td><b style={{marginLeft: 5}}>{this.props.type}</b></td>
                    </tr>
                )
            }
            <tr height={lineHeight}>
                <td></td>
                <td style={{lineHeight: 2}}>
                    {this.props.data && this.props.data.map((item, index) => {
                        let style = {};
                        if (item.href) {
                            style = {color: this.themeBgColor, cursor: "pointer"}
                        }
                        return <span key={index}>
                            <span>
                                {item.name}
                                {(index !== (this.props.data.length - 1)) && !item.href && "、"}
                                {/*{(index === (this.props.data.length - 1)) && !item.href && "。"}*/}
                            </span>
                            {
                                this.props.showHref ? (
                                    item.href ? (
                                        <span style={style} onClick={() => {
                                            window.open(item.href);
                                        }}
                                        >
                                            <br/>{item.href}<br/>
                                        </span>
                                    ) : (
                                        <span style={{color: this.themeBgColor, lineHeight: 2}}>
                                             <br/>
                                             链接无法获取
                                             <br/>
                                         </span>
                                    )
                                ) : ""
                            }
                        </span>;
                    })}
                    {/*{*/}
                    {/*    this.props.data?.length && this.props.data.every(item => !item.href) ? (*/}

                    {/*    ) : null*/}
                    {/*}*/}
                </td>
            </tr>
            </tbody>
        </table>;
    }

}

export default MediaList;